import state from "./state";

export default {
  isAuthenticated: state => !!state.token.access_token,
  getCredentials() {
    return state.credentials
  }
}
